/** @type {string} */
const UAT = 'uat';
/** @type {string} */
const QC = 'qc';
/** @type {string} */
const PRODUCTION = 'production';
/** @type {string} */
const PREPROD = 'preproduction';
/** @type {string} */
const DEVELOPMENT = 'development';

/** @type {string} */
const SITEGEN_ENV = process.env.SITEGEN_ENV || DEVELOPMENT;

/** @type {boolean} */
const IS_QC_ENV = SITEGEN_ENV === QC;
/** @type {boolean} */
const IS_UAT_ENV = SITEGEN_ENV === UAT;
/** @type {boolean} */
const IS_PRODUCTION_ENV = SITEGEN_ENV === PRODUCTION;
/** @type {boolean} */
const IS_PREPROD_ENV = SITEGEN_ENV === PREPROD;
/** @type {boolean} */
const IS_DEVELOPMENT_ENV = SITEGEN_ENV === DEVELOPMENT;

module.exports = {
    QC,
    UAT,
    PRODUCTION,
    PREPROD,
    DEVELOPMENT,
    IS_QC_ENV,
    IS_UAT_ENV,
    IS_PRODUCTION_ENV,
    IS_PREPROD_ENV,
    IS_DEVELOPMENT_ENV,
    SITEGEN_ENV
};
